import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import {
    StyledCheckbox,
    StyledRadioButton,
    StyledFormLabel,
} from './styledMaterialComponents';

const questionContainer = ({
    onCheckboxChange,
    question,
    onRadioButtonChange,
}) => {
    const getCheckboxes = () =>
        question.options.map(option => (
            <FormControlLabel
                control={
                    <StyledCheckbox
                        checked={option.checked || false}
                        onChange={() =>
                            onCheckboxChange(question.id, option.value)
                        }
                        value={option.value}
                    />
                }
                key={option.value}
                label={option.label}
            />
        ));

    const getRadioButtons = () =>
        question.options.map(option => (
            <FormControlLabel
                value={option.value}
                control={<StyledRadioButton />}
                label={option.label}
                key={option.value}
                color="default"
            />
        ));

    if (!question) {
        return null;
    }

    return (
        <FormControl>
            <StyledFormLabel><b>{question.question}</b></StyledFormLabel>
            {question.type === 'singleAnswer' && (
                <RadioGroup
                    name={question.id}
                    value={question.pickedAnswers}
                    onChange={event =>
                        onRadioButtonChange(question.id, event.target.value)
                    }>
                    {getRadioButtons()}
                </RadioGroup>
            )}
            {question.type === 'multipleAnswer' && (
                <FormGroup>{getCheckboxes()}</FormGroup>
            )}
        </FormControl>
    );
};

export default questionContainer;
